export const USER_SET_NOTIFICATIONS = '@user/set-notifications';
export const USER_GET_ACCESS_TOKEN = '@user/get-access-token';
export const USER_GET_USER = '@user/get-user';

